import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core'
import { Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { AbstractComponent, Department, DepartmentService, ScheduleWeek, Team, TeamService } from 'lib-trend-core'

@Component({
    selector: 'department-schedule-component',
    // templateUrl: './department-schedule.component.html',
    templateUrl: './department-schedule.v2.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DepartmentScheduleComponent extends AbstractComponent {
  departament: Department
  teamList: Team[] = []
  indexExpanded: number = -1

  showTeam: boolean = false
  indexEdit: number

  channelId: string;

  constructor(
    injector: Injector,
    public dialog: MatDialog,
    public departmentService: DepartmentService,
    public teamService: TeamService,
    public dialogRef: MatDialogRef<DepartmentScheduleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Department,
  ) {
    super(injector)
    this.createForm()
  }

  ngOnInit() {
    const departamentId = this.data._id;
    this.channelId = this.data.channel._id;
    this.isNew = !departamentId;

    const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    days.forEach((day) => {
      const control = this.formGroup.get(day);
      this.isEnabled(day);
      control.get('actived')?.valueChanges.subscribe(() => {
        this.isEnabled(day);
      });
    });

    if (departamentId) {
      this.departmentService.getById(departamentId).subscribe((departament) => {
        this.departament = departament
        if (this.departament?.schedules) {
          this.formGroup.patchValue({ ...this.departament.schedules })
        }
      })
    }
  }

  private createForm(): void {
    this.formGroup = this.formBuilder.group({
      monday: this.formBuilder.group({
        actived: [false],
        startTime: ['08:00'],
        endTime: ['18:00'],
      }),
      tuesday: this.formBuilder.group({
        actived: [false],
        startTime: ['08:00'],
        endTime: ['18:00'],
      }),
      wednesday: this.formBuilder.group({
        actived: [false],
        startTime: ['08:00'],
        endTime: ['18:00'],
      }),
      thursday: this.formBuilder.group({
        actived: [false],
        startTime: ['08:00'],
        endTime: ['18:00'],
      }),
      friday: this.formBuilder.group({
        actived: [false],
        startTime: ['08:00'],
        endTime: ['18:00'],
      }),
      saturday: this.formBuilder.group({
        actived: [false],
        startTime: ['08:00'],
        endTime: ['18:00'],
      }),
      sunday: this.formBuilder.group({
        actived: [false],
        startTime: ['08:00'],
        endTime: ['18:00'],
      }),
    });
  }

  close(): void {
    this.dialogRef.close(true);
  }

  save() {
    if (!this.formGroup.valid) {
      this.validateAllFormFields(this.formGroup)
      return
    }

    this.departament.schedules = {
      monday: this.formGroup.get('monday').value,
      tuesday: this.formGroup.get('tuesday').value,
      wednesday: this.formGroup.get('wednesday').value,
      thursday: this.formGroup.get('thursday').value,
      friday: this.formGroup.get('friday').value,
      saturday: this.formGroup.get('saturday').value,
      sunday: this.formGroup.get('sunday').value,
    } as ScheduleWeek;

    this.departmentService
      .update(this.departament._id, this.departament)
      .subscribe({
        next: (value) => {
          this.alertService.success(this.t('department.schedule.updateSuccess'))
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.alertService.error(err.error.message)
        },
        complete: () => { },
      })
  }

  isEnabled(value: string): void {
    if (this.formGroup.get(value).get('actived').value) {
      this.formGroup.get(value).get('startTime').setValidators([Validators.required]);
      this.formGroup.get(value).get('endTime').setValidators([Validators.required]);
      this.formGroup.get(value).get('startTime').enable();
      this.formGroup.get(value).get('endTime').enable();
    } else {
      this.formGroup.get(value).get('startTime').clearValidators();
      this.formGroup.get(value).get('endTime').clearValidators();
      this.formGroup.get(value).get('startTime').disable();
      this.formGroup.get(value).get('endTime').disable();
    }
  }
}
